/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton } from "@mui/material";
import { closelightbox } from "../../util/Functions";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";
import moment from 'moment';
import 'moment/locale/es';

const FilterDateMessage = (props) => {  
  const history = useHistory();
  const [disabled, setDisabled] = useState(true);
  const [startDate] = useState(moment(new Date()).subtract(1, 'month').format().slice(0, 10))
  const [endDate]= useState(moment(new Date()).format().slice(0, 10))
  const [zPos, setZPos] = useState(45)
  const [form, setForm] = useState({
    startDate: startDate,
    endDate: endDate,
    limit: 0,
  });
  const [error, setErrors] = useState({
    startDate: "",
    endDate: "",
    limit: "",
  });

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const init = () => {
    validateForm(form, error)
  };

  const send = async () => {
    props.changeLoader(true);
    setZPos(-1)

    let data = form;
    data["pageNumber"] = 1
    
    let request = await API.service( "concentratorMessages", data, props.pos, props.changeAlert, props.changeLoader, history );
    if (request.status === 200 && request.data.data.response === "OK") {
      let widg = request.data.data.widget;
      
      props.setWidgets(JSON.parse(JSON.stringify(widg)));
      props.updateNext("update");
      closelightbox();
    } else {
      props.setWidgets([]);
    }
    props.changeLoader(false);
    setZPos(45)
  };

  const changeValue = (field, e) => {
    let f = form;
    let er = error;

    if (field === "limit") {
      f[field] = Number(e.target.value);
      if (Number(e.target.value) > 100 || Number(e.target.value) < 1) {
        er[field] = "Indique un límite entre 0 y 100";
      } else {
        er[field] = "";
      }
    } else {
      f[field] = e.target.value;
      if (!e.target.value) {
        er[field] = "Dato obligatorio";
      } else {
        er[field] = "";
      }
    }

    setForm(JSON.parse(JSON.stringify(f)));
    setErrors(JSON.parse(JSON.stringify(er)));
    validateForm(f, er);
  };

  const validateForm = (f, err) => {
    if (f["limit"] && f["startDate"] && f["endDate"] && !err["limit"] && !err["startDate"] && !err["endDate"]) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  return (
    <Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
      <ModalStyle property={String(disabled)}>
        <DialogTitle>
          Búsqueda de Mensajes
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>

        <DialogContent>
          <Grid container spacing={2} sx={{ marginTop: "10px" }}>
            <Grid item xs={6}>
              <TextField
                value={form.startDate} onChange={changeValue.bind(this, "startDate")}	label="Fecha de Inicio"	size="small"	type={"date"}	fullWidth	InputProps={{inputProps: { max: new Date().toJSON().substr(0, 10)} }} error={error.startDate !== ""} helperText={error.startDate ? error.startDate : ''} InputLabelProps={{ shrink: true }}/>
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={form.endDate} onChange={changeValue.bind(this, "endDate")}	label="Fecha Final"	size="small" type={"date"}	fullWidth	InputProps={{inputProps: { max: new Date().toJSON().substr(0, 10)} }} error={error.endDate !== ""} helperText={error.endDate ? error.endDate : ''} InputLabelProps={{ shrink: true }}/>
            </Grid>
            <Grid item xs={6}>
              <TextField
                onChange={changeValue.bind(this, "limit")} label="Límite" error={error.limit !== ""} helperText={error.limit ? error.limit : ''} size="small" fullWidth />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>         
          <Button disabled={disabled} variant="contained" onClick={send.bind(this)} >Buscar</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog>          
  );
};
        
export default FilterDateMessage;
